import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import {getAthletes, linkAthleteToEvent, getAthletesByEvent, getShootingById, updateShooting} from "../../../db"; // 👈 update these as needed


const Athletes = ({ onClose, shooting }) => {

    const { t } = useTranslation();
    const [availableAthletes, setAvailableAthletes] = useState([]);

    useEffect(() => {
        let isMounted = true;

        const fetchAthletes = async () => {
            if (!shooting) return;

            try {
                let athletes;
                if (shooting.event) {
                    athletes = await getAthletesByEvent(shooting.event);
                } else {
                    athletes = await getAthletes();
                }

                if (isMounted) {
                    setAvailableAthletes(athletes);
                }
            } catch (error) {
                console.error("Failed to load athletes:", error);
            }
        };

        fetchAthletes();

        return () => {
            isMounted = false; // ✅ Prevent state update if unmounted
        };
    }, [shooting]);

    const handleSelectAthlete = async (athleteId) => {
        await updateShooting(shooting.id, { athlete: athleteId });
        onClose(); // close the modal
    };

    return (
        <div className="fixed inset-0 z-30 flex items-center justify-center">
            <div className="bg-black opacity-60 absolute inset-0" onClick={onClose}></div>
            <div className="bg-white p-10 relative w-[90rem] max-w-[90svw] max-h-[90svh] overflow-y-auto">
               <button onClick={onClose} className="absolute right-0 top-0 p-2 bg-[var(--light-color)] text-[var(--dark-color)]">
                <IconX className="w-6 h-auto" />
               </button>
                <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-xs px-2">
                    {availableAthletes.length > 0 ? (
                        availableAthletes.map((athlete) => (
                            <button
                                key={athlete.id}
                                className={`${athlete.id === shooting.athlete ? 'button-primary' : 'button-secondary'} flex-col !items-start justify-between`}
                                onClick={() => handleSelectAthlete(athlete.id)}
                            >
                                <div className="flex gap-1 items-center">
                                    {athlete.eventInfo && athlete.eventInfo.bib && (
                                        <div className={`${athlete.id === shooting.athlete ? 'bg-[var(--dark-color)] text-[var(--light-color)]' : 'bg-[var(--light-color)] text-[var(--dark-color)]'} aspect-[4/3] w-8 items-center justify-center inline-flex p-1 text-xs `}>
                                            {athlete.eventInfo.bib}
                                        </div>
                                    )}
                                    <span>{athlete.nickname || `${athlete.firstname} ${athlete.lastname}`}</span>
                                </div>
                            </button>
                        ))
                    ) : (
                        <p>TODO: no available athletes - create a new one</p>
                    )}
                </div>
                <div className="mt-6 px-2 text-xs">
                    <button
                        className={`${!shooting.athlete ? 'button-primary !bg-[var(--dark-color)] !text-[var(--light-color)]' : 'button-secondary'} !border-[var(--dark-color)] flex-col !items-start justify-between`}
                        onClick={() => handleSelectAthlete(false)}
                    >
                        {t("shooting.guest")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Athletes;